import { isObject } from "lodash"
import update from "immutability-helper"
import PropTypes from "prop-types"
import { isKeyInQueryString } from "./queryString"
import { getPeriodLabel } from "./dates"

export const ABSOLUTE_DATE_PROPTYPE = PropTypes.oneOfType([
  PropTypes.shape({
    startDate: PropTypes.string.isRequired,
    endDate: PropTypes.string.isRequired,
  }),
  PropTypes.shape({
    date: PropTypes.string.isRequired,
  }),
])

export function getDefaultDateRangeProps(period, startDate, endDate) {
  if (isObject(period)) {
    return {}
  }

  return {
    dateReducer: state => update(state, {
      $unset: ["period"],
      startDate: { $set: startDate },
      endDate: { $set: endDate },
    }),
    relativeDate: getPeriodLabel(period),
    absoluteDate: { startDate, endDate },
  }
}

export function getDefaultSingleDateProps(date) {
  if (isKeyInQueryString("date")) {
    return {}
  }

  return {
    dateReducer: state => update(state, {
      date: { $set: date },
    }),
    relativeDate: getPeriodLabel("1D"),
    absoluteDate: { date },
  }
}
